module.exports = __webpack_public_path__ + "media/customizations/collective/back-d754601d04f56661910a1d7d09d3dade.jpg";